// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RequestResetPassword_wrapper__3p4gg"};